<template>
  <div class="swaychat-row">
    <select :name="name" ref="input" :model="selected"
      @input="update($event.target.value)"
      :value="value"
      :class="{
        'swaychat-error': error
        }"
      >
      <option value="">{{ label }}</option>
      <option v-for="team in teams" :value="team.value">{{ team.label }}</option>
    </select>
  </div>
</template>

<script>

//use team data on widget and teams.
export default {
  props: [
    'label',
    'name',
    'value',
    'error'
  ],
  computed: {
      teams() {
        return this.$store.getters.getTeams
      }
  },
  methods: {
    update(v) {
      this.$emit('input', v)
    }
  }
}

</script>
